<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  *{
    margin: 0;
    padding: 0;
    font-family: 微软雅黑;
  }
  a{
    text-decoration: none;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue